import { Avatar, Flex, List, Typography } from "antd";
import { CVInterface } from "api/enumerator/Profile/dto";

const { Text } = Typography;

interface CvItemProp {
    item: CVInterface;
}

const getFileName = (filePath: string): string => {
    const cleanPath = filePath.split("?")[0];

    const fileName = cleanPath.substring(cleanPath.lastIndexOf("/") + 1);

    return fileName.includes(".") ? fileName : "CV_File.pdf";
};

export const CvItem = ({ item }: CvItemProp) => {
    let fileUrl: string | null = null;
    let fileName: string | null = null;

    if (typeof item.file === "string") {
        fileUrl = item.file;
        fileName = getFileName(item.file);
    } else if (Array.isArray(item.file) && item.file.length > 0) {
        fileUrl = item.file[0]?.url || null;
        fileName = item.file[0]?.name ? getFileName(item.file[0]?.name) : "CV_File.pdf";
    }

    if (!fileUrl) {
        return <Text type="danger">No CV available.</Text>;
    }

    return (
        <List.Item>
            <List.Item.Meta
                avatar={
                    <Avatar size={50} style={{ backgroundColor: "#22AD5C" }}>
                        CV
                    </Avatar>
                }
                title={<span style={{fontSize: '1.25rem', fontWeight: 'bold'}}>Curriculum Vitae</span>}
                description={
                    <Flex vertical>
                        <a href={fileUrl} rel="noreferrer" target="_blank">
                            <Text type="warning">{fileName}</Text>
                        </a>
                    </Flex>
                }
            />
        </List.Item>
    );
};
